import type { ProductLogoMediumProps } from '../types';

/**
 * 中サイズの Item（品目台帳 / Business Central）ロゴアイコン
 *
 * Figma 900_Assets node 3067:67735（クライアント指定）準拠。
 * - 背景: navy（#1A2142）の rounded square
 * - キューブ: teal（#57D7D9）の側面 2 面 + white の上面
 */
export function ProductLogoMediumItem({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return <svg width={size} height={size} viewBox="0 0 672 672" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <path d="M136.301 244.004C136.301 239.576 140.725 236.51 144.871 238.066L308.417 299.441C315.016 301.918 319.388 308.227 319.388 315.276V523.151C319.387 527.58 314.964 530.644 310.817 529.088L158.242 471.831C145.044 466.878 136.301 454.259 136.301 440.162V244.004Z" fill="#57D7D9" />
      <path d="M527.728 238.066C531.874 236.51 536.298 239.576 536.298 244.004V440.162C536.298 454.258 527.555 466.878 514.357 471.831L361.781 529.088C357.635 530.644 353.211 527.58 353.211 523.151V315.276C353.211 308.227 357.583 301.918 364.182 299.441L527.728 238.066Z" fill="#57D7D9" />
      <path d="M324.412 138.157C332.074 135.281 340.519 135.281 348.182 138.157L509.054 198.528C514.539 200.586 514.539 208.345 509.054 210.404L342.239 273.006C338.408 274.444 334.186 274.444 330.354 273.006L163.54 210.404C158.055 208.345 158.055 200.586 163.54 198.528L324.412 138.157Z" fill="white" />
    </svg>;
}